'use client';

import React, {
  createContext,
  useState,
  ReactNode,
  FunctionComponent,
} from 'react';

export interface AlertState {
  open: boolean;
  type: 'alert' | 'confirm' | 'wideAlert';
  message: string | React.ReactElement;
  onConfirm?: () => void;
  onCancel?: () => void;
  description?: string | React.ReactElement;
  cancelButtonLabel?: string;
  confirmButtonLabel?: string;
  onClose?: () => void;
  attentionMsg?: string;
  onSequenceClose?: () => void;
  cancelWithModal?: boolean;
  hideCancellation?: boolean;
  isSequenceActive?: boolean;
}

export type AlertSequenceItem = Omit<AlertState, 'open'>;

const initialState: AlertState = {
  open: false,
  type: 'alert',
  message: '',
  description: '',
  attentionMsg: '',
  isSequenceActive: false,
};

export const AlertContext = createContext<
  [AlertState, React.Dispatch<React.SetStateAction<AlertState>>]
>([initialState, () => {}]);

interface AlertProviderProps {
  children: ReactNode;
}

export const AlertProvider: FunctionComponent<AlertProviderProps> = ({
  children,
}) => {
  const [alertState, setAlertState] = useState<AlertState>(initialState);

  return (
    <AlertContext.Provider value={[alertState, setAlertState]}>
      {children}
    </AlertContext.Provider>
  );
};
